export const nowISO = () => new Date().toISOString();

export const safeParse = (value, fallback = null) => {
  if (typeof value !== 'string') {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

export const buildResult = ({ ok, data = null, error = null }) => ({
  ok,
  data,
  error
});

export const generateId = () => `${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
